import { render, staticRenderFns } from "./RedeemGiftCode.vue?vue&type=template&id=b456bad4&scoped=true&"
import script from "./RedeemGiftCode.vue?vue&type=script&lang=js&"
export * from "./RedeemGiftCode.vue?vue&type=script&lang=js&"
import style0 from "./RedeemGiftCode.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RedeemGiftCode.vue?vue&type=style&index=1&id=b456bad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b456bad4",
  null
  
)

export default component.exports